import { Group } from '@mantine/core';
import type { EntityViolationsOut, PolicyOut } from '@repo/api-codegen';
import { useStyles } from '../styles';
import { PolicyColumnContent } from './PolicyColumnContent';
import { PolicyColumnTableHeader } from './PolicyColumnTableHeader';

export function PolicyColumnTable({
	columns,
	policy,
}: {
	columns: EntityViolationsOut[];
	policy: PolicyOut;
}) {
	const { classes } = useStyles();
	return (
		<Group align="center" p={0} className={classes.columnTable} spacing={0}>
			<PolicyColumnTableHeader />
			<PolicyColumnContent columns={columns} policy={policy} />
		</Group>
	);
}
